<p class="page-title mb-4">{{labelPageTitle}}</p>
<div class="mb-5">パスワードは「8文字以上の大文字・小文字両方を含む半角英字と半角数字の組み合わせ」で設定をお願い致します。</div>
<div class="row justify-content-center">
  <div class="col-sm-4 col-xs-12">
    <form [formGroup]="passGroup">
      <div class="form-group">
        <label class="col-form-label w-100 origin-form-label">{{labelOldPass}}</label>
        <div class="password-wrap mb-4">
          <input id="oldPass" name="oldPass" [attr.type]="oldPassType" [formControl]="oldPass" class="w-100 text-left"/>
          <span class="eye-style">
            <span *ngIf="oldPassType === 'password'" class="oi oi-eye text-muted" (click)="oldPassType = 'text';"></span>
            <span *ngIf="oldPassType === 'text'" class="oi oi-eye text-danger" (click)="oldPassType = 'password';"></span>
          </span>
        </div>
      </div>
      <div class="form-group">
        <label class="col-form-label w-100 origin-form-label">{{labelNewPass}}</label>
        <div class="password-wrap mb-4">
          <input id="newPass" name="newPass" [attr.type]="newPassType" [formControl]="newPass" class="w-100 text-left"/>
          <span class="eye-style">
            <span *ngIf="newPassType === 'password'" class="oi oi-eye text-muted" (click)="newPassType = 'text';"></span>
            <span *ngIf="newPassType === 'text'" class="oi oi-eye text-danger" (click)="newPassType = 'password';"></span>
          </span>
        </div>
      </div>
      <div class="form-group">
        <label class="col-form-label w-100 origin-form-label">{{labelNewPassConfirm}}</label>
        <div class="password-wrap mb-4">
          <input id="newPassConfirm" name="newPassConfirm" [attr.type]="newPassConfirmType" [formControl]="newPassConfirm" class="w-100 text-left"/>
          <span class="eye-style">
            <span *ngIf="newPassConfirmType === 'password'" class="oi oi-eye text-muted" (click)="newPassConfirmType = 'text';"></span>
            <span *ngIf="newPassConfirmType === 'text'" class="oi oi-eye text-danger" (click)="newPassConfirmType = 'password';"></span>
          </span>
        </div>
      </div>
      <button type="button" class="btn btn-primary btn-block mt-5" (click)="clickChangePassword()">パスワード変更</button>
    </form>
  </div>
</div>

